<template>
  <div class="scores">
    <div class="row" v-if="lastTopWord">
      <div class="col-12 best-word">
        Meilleur mot : {{lastTopWordPoints}} pts avec
        <span class="ref">{{lastTopWord.split(' ')[0]}}</span>
        <span class="clickable"
          v-on:click="displayDefinition(lastTopWord)">
        {{lastTopWord.split(' ')[1]}}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        Total top : {{totalTop}} {{pluralize(totalTop, 'pt')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table table-stripped table-sm">
          <thead>
            <tr>
              <th>Joueur</th>
              <th></th>
              <th>Score</th>
              <th>% du top</th>
              <th>Dernier mot validé</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="score in scores"
              v-bind:key="score.userId"
              v-bind:class="scoreTdClass(score)">
              <td>
                <Player
                  v-bind:username="score.username"
                  v-bind:userId="score.userId"
                  v-bind:picture="score.picture"
                />
              </td>
              <td>
                <img src="/static/star.svg" class="star"
                v-if="score.points === lastTopWordPoints"
                title="Bien joué !"/>
              </td>
              <td>{{score.total}}pts</td>
              <td>{{(percentageFromTop(score.total)).toFixed(2)}}%</td>
              <td v-if="score.reference">
                <span class="clickable"
                v-on:click="displayDefinition(score.reference)">{{score.reference}}</span>
                {{score.points}}pts
                <span class="bonus"
                title="Bonus pour être le seul joueur à marquer ce super score"
                v-if="score.bonus">
                  BONUS +{{score.bonus}}</span>
              </td>
              <td v-else class="text-center">-</td>
            </tr>
            <tr v-if="scores.length === 0" class="text-center">
              <td colspan="4">Aucun score
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { pluralize } from '../../filters';
import iam from '../../iam';
import Player from '../Player.vue';

export default {
  name: 'GameScores',
  emits: ['displayDefinition'],
  components: { Player },
  props: {
    scores: {
      type: Array,
      required: true,
    },
    totalTop: {
      type: Number,
      required: true,
    },
    lastTopWord: {
      type: String,
      required: false,
    },
    lastTopWordPoints: {
      type: Number,
      required: true,
    },
  },
  methods: {
    pluralize,
    scoreTdClass(score) {
      return {
        me: iam.getConnectedUser().id === score.userId,
      };
    },
    percentageFromTop(score) {
      return this.totalTop > 0
        ? (1 - ((this.totalTop - score) / this.totalTop)) * 100
        : 100;
    },
    displayDefinition(word) {
      this.$emit('displayDefinition', word.split(' ')[1]);
    },
  },
};
</script>

<style scoped>
.scores{
  margin-top: 1.2rem;
  padding-top: 1rem;
  border-top: 1px solid grey;
  font-size: 0.8rem;
}
.ref{
  font-style: italic;
}
.me td{
  color: #00579a;
}

.table thead th, .table td{
  font-size: 0.8rem;
  vertical-align: middle;
}
.bonus {
  font-size: 0.70rem;
  color: #CE0F69;
}
.best-word {
  color: green;
  font-size: 1.3rem;
}
.clickable{
  cursor: pointer;
}

img{
  width: 40px;
  margin-right: 4px;
}
img.star{
  width: 15px;
  margin-right: 0px;
}
</style>
